import { FC, ReactNode } from 'react'
import Svg, { SvgProps } from '@client-hub/shared/react/components/Svg'
import { useLogoSrcUrl } from 'hooks'

type Props = {
  variant?: 'default' | 'dark'
  fallback?: ReactNode
} & Omit<SvgProps, 'src'>

const ClientLogo: FC<Props> = ({ variant = 'default', ...rest }) => {
  const logoSrc = useLogoSrcUrl(variant)
  return logoSrc ? <Svg {...rest} src={logoSrc} aria-label="Client Logo" /> : null
}

export default ClientLogo
